import type { FaireProductEntity } from "../../entity_types/product";

export const p_kcf7dvv9nm: FaireProductEntity = {
  token: "p_kcf7dvv9nm",
  type: "product",
  name: "Sinus Steamers-No Labels",
  brandToken: "b_xvt273bhwc",
  brandName: "Herbal Rose Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/e6711e5793bb113b27d7eee959dd43f40ed0a6034d8931699a8bd56ca2affd98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c1e0423b4e2f3ccc93059bf49de7c381e052f58f1307ee13db553f5f9858a27.jpeg",
  ],
  priceDollars: 4.12,
  description:
    "A warming herbal steam to help clear congestion and support easy breathing.\n• Great for cold & allergy season\n• Comforting, aromatic herbs\n• Simple home ritual\n\nA fast-moving seasonal item—many shops reorder sinus steamers every 4–6 weeks during peak season.\n'\nOur unique blend of Eucalyptus, Rosemary, and Peppermint to take a deep breath of relief. \n\n*10 steamers per case\n\nEach bag comes sealed with 8g dried herbs. All herbs are ethically/organically sourced.\n\n*No labels on products, add your own labels and branding to products. Directions template emailed upon request.\n\n*Eucalyptus leaves may vary in color and fragrance depending on batch",
  tags: [],
  msrpDollars: 8.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:46.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
